<template>
    <div>
        <div
            class="xl:col-span-6 rounded-xl border border-theme-border bg-theme-card"
        >
            <div
                class="px-5 py-4 border-b border-theme-border font-semibold text-lg"
            >
                ⚡ Herramientas
            </div>

            <div class="p-5 space-y-4">
                <div v-if="cardLinksFavorites.length">
                    <h4 class="text-xs font-semibold text-theme-muted mb-2">
                        Favoritos
                    </h4>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
                        <ToolCard
                            v-for="link in cardLinksFavorites"
                            :key="link.url"
                            :link="link"
                            :expandable="false"
                            :is-favorite="true"
                            @click="onNavigate"
                            @middle-click="onMiddleClick"
                            @toggle-favorite="onToggleFavorite"
                        />
                    </div>
                </div>

                <div v-if="recentLinks.length">
                    <h4 class="text-xs font-semibold text-theme-muted mb-2">
                        Visto recientemente
                    </h4>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
                        <ToolCard
                            v-for="link in recentLinks"
                            :key="link.url"
                            :link="link"
                            :expandable="false"
                            :is-favorite="isFavorite(link)"
                            @click="onNavigate"
                            @middle-click="onMiddleClick"
                            @toggle-favorite="onToggleFavorite"
                        />
                    </div>
                </div>

                <div v-if="featuredLinks.length">
                    <h4 class="text-xs font-semibold text-theme-muted mb-2">
                        Explora por área
                    </h4>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
                        <ToolCard
                            v-for="link in featuredLinks"
                            :key="link.url"
                            :link="link"
                            :expandable="false"
                            :is-favorite="isFavorite(link)"
                            @click="onNavigate"
                            @middle-click="onMiddleClick"
                            @toggle-favorite="onToggleFavorite"
                        />
                    </div>
                </div>

                <div class="pt-2 text-center border-t border-theme-border">
                    <button
                        type="button"
                        class="text-sm font-medium text-theme-primary hover:underline"
                        @click="openToolsModal"
                    >
                        Ver todas las acciones →
                    </button>
                </div>
            </div>
        </div>

        <ToolsCatalogModal v-model="isToolsModalOpen" />
    </div>
</template>
<script>
import { mapGetters, mapMutations, mapState } from "vuex";

import ToolCard from "@/components/utils/ToolCard.vue";
import ToolsCatalogModal from "@/components/utils/ToolsCatalogModal.vue";

const RECENT_SLOTS = 4;
const FEATURED_SLOTS = 8;

export default {
    name: "AppTools",
    components: {
        ToolCard,
        ToolsCatalogModal
    },
    data: () => ({
        isToolsModalOpen: false
    }),
    computed: {
        ...mapState("control", {
            allCardLinksAvailable: "cardLinksAvailable",
            allCardLinksReviewed: "cardLinksReviewed",
            allCardLinksFavorites: "cardLinksFavorites"
        }),
        ...mapGetters("control", ["isCardLinkVisible"]),
        // Sin las herramientas de features que el tenant tiene apagadas.
        cardLinksAvailable() {
            return this.allCardLinksAvailable.filter(this.isCardLinkVisible);
        },
        cardLinksReviewed() {
            return this.allCardLinksReviewed.filter(this.isCardLinkVisible);
        },
        cardLinksFavorites() {
            return this.allCardLinksFavorites.filter(this.isCardLinkVisible);
        },
        recentLinks() {
            const favoriteUrls = new Set(
                this.cardLinksFavorites.map((link) => link.url)
            );
            return this.cardLinksReviewed
                .filter((link) => !favoriteUrls.has(link.url))
                .slice(0, RECENT_SLOTS);
        },
        availableExcludingShown() {
            const shownUrls = new Set(
                [...this.cardLinksFavorites, ...this.recentLinks].map(
                    (link) => link.url
                )
            );
            return this.cardLinksAvailable.filter(
                (link) => !shownUrls.has(link.url)
            );
        },
        featuredLinks() {
            return this.availableExcludingShown.slice(0, FEATURED_SLOTS);
        }
    },
    methods: {
        ...mapMutations("control", [
            "PUSH_RECENT_LINK",
            "TOGGLE_FAVORITE_LINK"
        ]),
        isFavorite(link) {
            return this.cardLinksFavorites.some(
                (item) => item.url === link.url
            );
        },
        onNavigate(link) {
            this.$router
                .push(link.url)
                .then(() => this.PUSH_RECENT_LINK(link))
                .catch(() => {});
        },
        onMiddleClick(link) {
            this.PUSH_RECENT_LINK(link);
            window.open(this.$router.resolve(link.url).href, "_blank");
        },
        onToggleFavorite(link) {
            this.TOGGLE_FAVORITE_LINK(link);
        },
        openToolsModal() {
            this.isToolsModalOpen = true;
        }
    }
};
</script>
